<template>
    <div class="container-fluid">
        <div class="row">
            <b-navbar toggleable="lg" type="dark" variant="" class="p-3 px-lg-5">
                <b-navbar-brand href="#" class="text-lg-left">
                    <router-link to="/" active-class="logo-link">
                        <img src="../../assets/images/logo/stdenislogo.jpeg" alt="saint denis logo"> St. Denis
                    </router-link>
                </b-navbar-brand>
                <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
                <b-collapse id="nav-collapse" is-nav>
                    <!-- Right aligned nav items -->
                    <b-navbar-nav class="ml-auto">
                        <b-navbar-nav>
                            <!--                            <b-nav-item @click.prevent="navigate_to_page('dashboard')" active>Dashboard</b-nav-item>-->
                            <b-nav-item-dropdown :text="baptismalName.toUpperCase()" right>
                                <b-dropdown-item href="#" @click.prevent="logout">
                                    <a><i class="icon ion-md-log-out text-white"></i> logout</a>
                                </b-dropdown-item>
                            </b-nav-item-dropdown>
                        </b-navbar-nav>

                        <div>
                            <div class="user-icon" :style="{'background-image': 'url('+profileIcon+')'}"></div>
                        </div>


                    </b-navbar-nav>
                </b-collapse>
            </b-navbar>
            <div class="side-navbar-toggler" @click.prevent="displaySideNavBar = !displaySideNavBar">
                <i class="icon ion-md-home text-white"></i>
            </div>
            <div class="side-navbar" :class="[displaySideNavBar?'animated slideInLeft show':'']">
                <div class="col-12 text-right side-navbar-toggler-close" style="font-size: 16px"
                     @click.prevent="displaySideNavBar = false">
                    <i class="icon ion-md-close-circle text-white"></i>
                </div>
                <router-link :to="{name:'Dashboard'}">
                    <i class="icon ion-md-browsers"></i> Dashboard
                </router-link>
                <router-link :to="{name:'FamilyMembers'}">
                    <i class="icon ion-md-contacts"></i> Family Members
                </router-link>
                <a href="#">
                    <i class="icon ion-md-cash"></i> Due Payments
                </a>
                <a href="#">
                    <i class="icon ion-md-filing"></i> Upcoming Events
                </a>
            </div>
        </div>
        <div class="row">
            <div class="col-12 other-opt ">
                <div class="float-lg-right add-fam pd-t-100">
                    <b-button class="btn btn-info text-white" v-b-modal.modal-1>
                        <i class="icon ion-md-add-circle-outline text-white"></i> add family member
                    </b-button>
                    <!--                    <button class="btn btn-info text-white">-->
                    <!--                        <i class="icon ion-md-add-circle-outline text-white"></i> add family member-->
                    <!--                    </button>-->
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <!-- Add Family Member Modal -->
                <b-modal id="modal-1" title="Add Family Member" size="lg" ok-title="Cancel" ok-only ok-variant="dark">
                    <form role="form" @submit.prevent="validate_form_fields" class="vld-parent" ref="formContainer">
                        <div class="col-12 signup-container">
                            <div class="row">
                                <!-- Sign up Header -->
                                <div class="col-12 signup-head">
                                    <div class="row">
                                        <div class="col-lg-2 col-md-12 head-img text-center">
                                            <img src="../../assets/images/logo/stdenislogo.jpeg" alt=""
                                                 class="img-fluid">
                                        </div>
                                        <div class="col-lg-10 col-md-12 head-text" style="padding-top:10px">
                                            <h1 class="text text-danger text-center text-capitalize">
                                                St. Denis, Catholic church
                                            </h1>
                                            <h4 class="text-center">
                                                3/13, Thomas Drive, Akoka/ Bariga, Lagos
                                            </h4>
                                            <p class="text-center">Tel:+2348165214047&nbsp;&nbsp;Email:stdenis@stdenisakoka.org</p>
                                        </div>
                                    </div>
                                </div>
                                <!-- Signup body -->
                                <div class="col-12 signup-body">
                                    <!-- first row -->
                                    <div class="row signup-body-1">
                                        <div class="col-lg-12 col-md-12 head-text">
                                            <h4 class="text-center m-b-20">Membership Registration Form</h4>
                                        </div>
                                        <div class="col-lg-4 col-md-12 offset-lg-4 p-t-20">
                                            <div class="pic-frame" @click="toggle_passport_upload">
                                                <div class="frame-overlay">
                                                    <span class="text text-dark"><i class="icon ion-md-hand"></i> click to upload passport</span>
                                                </div>
                                                <input type="file" class="frame-file" accept="image/*"
                                                       id="stdenis-passport" @change="verify_profile_pic_upload">
                                            </div>
                                        </div>

                                    </div>
                                    <!-- Second row -->
                                    <div class="row signup-body-2">
                                        <div class="col-12 signup-body-header">
                                            <h2 class="text-center">Section A</h2>
                                            <h4 class="m-b-20">Personal Data</h4>
                                        </div>
                                        <!--                                    <div class="col-lg-6 col-md-12 gap">-->
                                        <!--                                        <label for="reg_no" class="text-left">Reg. No: (SDCC) <span class="text text-danger">(for Office use only)</span> </label>-->
                                        <!--                                        <input type="text" name="reg_no" id="reg_no" class="form-control" placeholder="Reg Number" value="#8585GCK&JK"  disabled>-->
                                        <!--                                    </div>-->
                                        <div class="col-lg-6 col-md-12 gap">
                                            <label for="surname" class="text-left">Surname:</label>
                                            <input type="text" class="form-control" id="surname" placeholder="Surname"
                                                   v-model="surname" autofocus>
                                        </div>
                                        <div class="col-lg-6 col-md-12 gap">
                                            <label for="othername" class="text-left">Othername:</label>
                                            <input type="text" class="form-control" id="othername"
                                                   placeholder="Other Name" v-model="othername">
                                        </div>
                                        <div class="col-lg-6 col-md-12 gap">
                                            <label for="baptismalname" class="text-left">Baptismal Name:</label>
                                            <input type="text" class="form-control" id="baptismalname"
                                                   placeholder="Baptismal Name" v-model="baptismal_name">
                                        </div>
                                        <div class="col-lg-6 col-md-12 gap">
                                            <label for="sex" class="text-left">Sex:</label>
                                            <select class="form-control" v-model="sex" id="sex">
                                                <option value="">Select an option</option>
                                                <option value="male">Male</option>
                                                <option value="female">Female</option>
                                            </select>
                                        </div>
                                        <div class="col-lg-6 col-md-12 gap">
                                            <label for="maritalStatus" class="text-left">Marital Status:</label>
                                            <select class="form-control" v-model="maritalStatus" id="maritalStatus">
                                                <option value="">Select an option</option>
                                                <option value="single">Single</option>
                                                <option value="married">Married</option>
                                            </select>
                                        </div>
                                        <div class="col-lg-6 col-md-12 gap">
                                            <label for="dob" class="text-left">Date of Birth:</label>
                                            <input type="date" class="form-control" id="dob" v-model="dob">
                                        </div>
                                        <div class="col-lg-6 col-md-12 gap">
                                            <label for="resident_addr" class="text-left">Residential Address:</label>
                                            <input type="text" class="form-control" id="resident_addr"
                                                   placeholder="Address" v-model="residential_addr">
                                        </div>
                                        <div class="col-lg-6 col-md-12 gap">
                                            <label for="occupation" class="text-left">Occupation:</label>
                                            <input type="text" class="form-control" id="occupation"
                                                   placeholder="Occupation" v-model="occupation">
                                        </div>
                                        <div class="col-lg-6 col-md-12 gap">
                                            <label for="mobile_tel" class="text-left">Mobile Number:</label>
                                            <input type="tel" class="form-control" id="mobile_tel"
                                                   placeholder="Mobile Number" v-model="mobile_no">
                                        </div>
                                        <div class="col-lg-6 col-md-12 gap">
                                            <label for="u_email" class="text-left">Email Address:</label>
                                            <input type="email" class="form-control" id="u_email"
                                                   placeholder="Email Address" v-model="email">
                                        </div>
                                        <div class="col-lg-6 col-md-12 gap">
                                            <label for="bcc_center" class="text-left">B.C.C Center:</label>
                                            <select class="form-control" v-model="bcc_center" id="bcc_center">
                                                <option value="">Select a BCC Center</option>
                                                <option v-for="centers in bcc_centerID.length"
                                                        :value="bcc_centerID[centers-1]" :key="centers">
                                                    {{bcc_centerName[centers-1]}}
                                                </option>
                                            </select>
                                        </div>
                                        <div class="col-lg-6 col-md-12 gap">
                                            <label for="u_joined" class="text-left">Year of Joining Church:</label>
                                            <input type="number" class="form-control" id="u_joined"
                                                   placeholder="Year Joined" v-model="yr_joined_church">
                                        </div>
                                        <div class="col-lg-6 col-md-12 gap">
                                            <div class="row">
                                                <!--                                             Society Details-->
                                                <div class="col-12 gap text-left">
                                                    <label>Statutory Organization:</label>
                                                    <input type="text" class="form-control" :value="curr_society"
                                                           disabled>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 gap">
                                            <div class="row">
                                                <div class="col-12 gap">
                                                    <h4>Societal Details</h4>
                                                </div>
                                                <div class="col-lg-12 col-md-12 gap">
                                                    <h6 class="text-left">Is he/she a member of any society?<br>
                                                    </h6>
                                                    <div class="col-12 text-left">
                                                        <div class="form-check form-check-inline">
                                                            <label class="input-mask no-width form-check-input"
                                                                   :class="[society_membership?'active':'']"
                                                                   @click="toggle_inputs('society_membership', 'yes')">
                                                                <input class="form-check-input" type="radio"
                                                                       id="society_membership1">
                                                            </label>
                                                            <label for="society_membership1"
                                                                   class="text-left no-width form-check-label">Yes</label>
                                                        </div>
                                                        <div class="form-check form-check-inline">
                                                            <label class="input-mask no-width form-check-input"
                                                                   :class="[society_membership?'':'active']"
                                                                   @click="toggle_inputs('society_membership', 'no')">
                                                                <input class="form-check-input" type="radio"
                                                                       id="society_membership2">
                                                            </label>
                                                            <label for="society_membership2"
                                                                   class="text-left no-width form-check-label">No</label>
                                                        </div>
                                                    </div>
                                                    <div v-if="society_membership">
                                                        <span><p class="text-info">select the societies he/she belongs to:</p></span>
                                                    </div>
                                                    <transition name="custom-name" enter-active-class="animated fadeIn"
                                                                leave-active-class="animated fadeOut">
                                                        <template v-if="society_membership">
                                                            <v-select :options="societiesName" v-model="society_names"
                                                                      :reduce="society => society.id" label="society"
                                                                      multiple></v-select>
                                                        </template>
                                                    </transition>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 gap">
                                            <div class="row">
                                                <!-- Sacramental Details-->
                                                <div class="col-12 gap">
                                                    <h4>Sacramental Details</h4>
                                                </div>
                                                <div class="col-12 gap">
                                                    <div class="row">
                                                        <div class="col-lg-6 col-md-12">
                                                            <h6 class="text-left">Are you Baptized?</h6>
                                                            <div class="col-12 text-left">
                                                                <div class="form-check form-check-inline">
                                                                    <label class="input-mask no-width form-check-input"
                                                                           :class="[is_baptized?'active':'']"
                                                                           @click="toggle_inputs('baptism', 'yes')">
                                                                        <input class="form-check-input" type="radio"
                                                                               id="baptized_yes">
                                                                    </label>
                                                                    <label for="baptized_yes"
                                                                           class="text-left no-width form-check-label">Yes</label>
                                                                </div>
                                                                <div class="form-check form-check-inline">
                                                                    <label class="input-mask no-width form-check-input"
                                                                           :class="[is_baptized?'':'active']"
                                                                           @click="toggle_inputs('baptism', 'no')">
                                                                        <input class="form-check-input" type="radio"
                                                                               id="baptized_no">
                                                                    </label>
                                                                    <label for="baptized_no"
                                                                           class="text-left no-width form-check-label">No</label>
                                                                </div>
                                                            </div>
                                                            <transition name="custom-name"
                                                                        enter-active-class="animated fadeIn"
                                                                        leave-active-class="animated fadeOut">
                                                                <template v-if="is_baptized">
                                                                    <div>
                                                                        <h6 class="text-left">Date of Baptism</h6>
                                                                        <div class="text-left">
                                                                            <input type="date" class="form-control"
                                                                                   v-model="baptized_date">
                                                                        </div>
                                                                    </div>
                                                                </template>
                                                            </transition>
                                                        </div>
                                                        <div class="col-lg-6 col-md-12">
                                                            <h6 class="text-left">Are you a Communicant?</h6>
                                                            <div class="col-12 text-left">
                                                                <div class="form-check form-check-inline">
                                                                    <label class="input-mask no-width form-check-input"
                                                                           :class="[is_communicant?'active':'']"
                                                                           @click="toggle_inputs('communicant', 'yes')">
                                                                        <input class="form-check-input" type="radio"
                                                                               id="communicant_yes">
                                                                    </label>
                                                                    <label for="communicant_yes"
                                                                           class="text-left no-width form-check-label">Yes</label>
                                                                </div>
                                                                <div class="form-check form-check-inline">
                                                                    <label class="input-mask no-width form-check-input"
                                                                           :class="[is_communicant?'':'active']"
                                                                           @click="toggle_inputs('communicant', 'no')">
                                                                        <input class="form-check-input" type="radio"
                                                                               id="communicant_no">
                                                                    </label>
                                                                    <label for="communicant_no"
                                                                           class="text-left no-width form-check-label">No</label>
                                                                </div>
                                                            </div>
                                                            <transition name="custom-name"
                                                                        enter-active-class="animated fadeIn"
                                                                        leave-active-class="animated fadeOut">
                                                                <template v-if="is_communicant">
                                                                    <div>
                                                                        <h6 class="text-left">Date of Communion</h6>
                                                                        <div class="text-left">
                                                                            <input type="date" class="form-control"
                                                                                   v-model="communion_date">
                                                                        </div>
                                                                    </div>
                                                                </template>
                                                            </transition>
                                                        </div>
                                                        <div class="col-lg-6 col-md-12">
                                                            <h6 class="text-left">Are you Confirmed?</h6>
                                                            <div class="col-12 text-left">
                                                                <div class="form-check form-check-inline">
                                                                    <label class="input-mask no-width form-check-input"
                                                                           :class="[is_confirmed?'active':'']"
                                                                           @click="toggle_inputs('confirmed', 'yes')">
                                                                        <input class="form-check-input" type="radio"
                                                                               id="confirmed_yes">
                                                                    </label>
                                                                    <label for="confirmed_yes"
                                                                           class="text-left no-width form-check-label">Yes</label>
                                                                </div>
                                                                <div class="form-check form-check-inline">
                                                                    <label class="input-mask no-width form-check-input"
                                                                           :class="[is_confirmed?'':'active']"
                                                                           @click="toggle_inputs('confirmed', 'no')">
                                                                        <input class="form-check-input" type="radio"
                                                                               id="confirmed_no">
                                                                    </label>
                                                                    <label for="confirmed_no"
                                                                           class="text-left no-width form-check-label">No</label>
                                                                </div>
                                                            </div>
                                                            <transition name="custom-name"
                                                                        enter-active-class="animated fadeIn"
                                                                        leave-active-class="animated fadeOut">
                                                                <template v-if="is_confirmed">
                                                                    <div>
                                                                        <h6 class="text-left">Date Confirmed</h6>
                                                                        <div class="text-left">
                                                                            <input type="date" class="form-control"
                                                                                   v-model="confirmed_date">
                                                                        </div>
                                                                    </div>
                                                                </template>
                                                            </transition>
                                                        </div>
                                                        <div class="col-lg-6 col-md-12">
                                                            <h6 class="text-left">Are you Married in the church?</h6>
                                                            <div class="col-12 text-left">
                                                                <div class="form-check form-check-inline">
                                                                    <label class="input-mask no-width form-check-input"
                                                                           :class="[is_married?'active':'']"
                                                                           @click="toggle_inputs('married', 'yes')">
                                                                        <input class="form-check-input" type="radio"
                                                                               id="married_yes">
                                                                    </label>
                                                                    <label for="married_yes"
                                                                           class="text-left no-width form-check-label">Yes</label>
                                                                </div>
                                                                <div class="form-check form-check-inline">
                                                                    <label class="input-mask no-width form-check-input"
                                                                           :class="[is_married?'':'active']"
                                                                           @click="toggle_inputs('married', 'no')">
                                                                        <input class="form-check-input" type="radio"
                                                                               id="married_no">
                                                                    </label>
                                                                    <label for="married_no"
                                                                           class="text-left no-width form-check-label">No</label>
                                                                </div>
                                                            </div>
                                                            <transition name="custom-name"
                                                                        enter-active-class="animated fadeIn"
                                                                        leave-active-class="animated fadeOut">
                                                                <template v-if="is_married">
                                                                    <div>
                                                                        <h6 class="text-left">Name of Parish</h6>
                                                                        <div class="text-left">
                                                                            <input type="text" class="form-control"
                                                                                   v-model="married_parish">
                                                                        </div>
                                                                        <h6 class="text-left">Date of Marriage</h6>
                                                                        <div class="text-left">
                                                                            <input type="date" class="form-control"
                                                                                   v-model="married_date">
                                                                        </div>
                                                                    </div>
                                                                </template>
                                                            </transition>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-md-12 gap">
                                            <h6>Upload Your Signature</h6>
                                            <div class="sig-container">
                                                <label class="hint-text">
                                                <span style="display: block;background-color: rgba(50,50,50,.7)">
                                                <i class="icon ion-md-checkbox-outline text-white"></i><span
                                                        class="inner-hint text-white"> Upload your Signature here</span>
                                                <input type="file" id="signature" @change="read_sig_url">
                                                </span>
                                                </label>
                                            </div>
                                        </div>

                                    </div>
                                    <!-- submit area-->
                                    <div class="row">
                                        <div class="col-lg-6 col-md-12 offset-lg-3">
                                            <button type="submit" class="btn stdenis-btn">Submit</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </b-modal>
            </div>
        </div>
    </div>
</template>

<script>
    import vSelect from 'vue-select'
    import 'vue-select/dist/vue-select.css'

    import Swal from 'sweetalert2/dist/sweetalert2.js'
    import {firestoreDB, rawFirestore} from '../../config/firebase'
    import {firestoreTimeStamp} from "../../config/firebase";
    import {firestoreStorage} from "../../config/firebase";

    const parishioners = firestoreDB.collection("parishioners");
    const familyCollection = firestoreDB.collection("families");
    const parishionerStorageREF = firestoreStorage.ref();
    const societiesREF = firestoreDB.collection("societies");
    const zonesREF = firestoreDB.collection("zones");

    export default {
        name: "DashNav",
        data() {
            return {
                show: true,
                profileIcon: "",
                baptismalName: "",
                parishionerData: {
                    sex: '',
                    familyID: ''
                },
                parishionerID: sessionStorage.getItem('dashboardID'),


                profile_pic_url: '',
                profile_pic: '',
                profile_pic_name: '', profile_pic_ext: '',
                parishioners_doc_ref: '',
                form_number: '',
                date_registered: '',
                reg_no: '',
                maritalStatus: '',
                surname: '', othername: '', sex: '',
                baptismal_name: '', baptismal_date: '',
                dob: '', residential_addr: '',
                occupation: '',
                mobile_no: '', email: '',
                bcc_center: '', bcc_centerID: [], bcc_centerName: [],
                yr_joined_church: '',
                organization_name: '',
                society_membership: false, societiesID: [], societiesName: [],
                society_names: [],
                society_ID: "",
                is_baptized: false, baptized_date: '',
                is_communicant: false, communion_date: '',
                is_confirmed: false, confirmed_date: '',
                is_married: false, married_date: '', married_parish: '',
                this_year() {
                    let now = new Date();
                    return now.getFullYear();
                },
                fullPage: false,
                signature_url: '',
                signature_ext: '',
                profilePicRef: '',
                signatureRef: '',

                displaySideNavBar: false
            }
        },
        computed: {
            curr_society: function () {
                return this.determineOrganization(this.dob);
            },
        },
        watch: {
            is_married: function (newval) {
                if (newval === true) {
                    if (this.sex === this.parishionerData.sex) {
                        this.display_alert("Hey", "You can not select the same gender for the same married value", "warning");
                        this.is_married = false
                    }
                }
            },
            sex: function (newval) {
                if (this.is_married === true) {
                    if (newval === this.parishionerData.sex) {
                        this.display_alert("Hey", "You can not select the same gender for the same married value", "warning");
                        this.is_married = false
                    }
                }
            }
        },
        methods: {
            navigate_to_page(page) {
                switch (page) {
                    case 'dashboard':
                        this.$router.push({path: '/dashboard'});
                        break;
                }

            },
            toggle_inputs: function (context, value) {
                switch (context) {
                    // Society Based selections
                    case 'society_membership':
                        switch (value) {
                            case 'yes':
                                this.society_membership = true;
                                break;
                            case 'no':
                                this.society_membership = false;
                                break;
                        }
                        break;
                    case 'baptism':
                        switch (value) {
                            case 'yes':
                                this.is_baptized = true;
                                break;
                            case 'no':
                                this.is_baptized = false;
                                break;
                        }
                        break;
                    case 'communicant':
                        switch (value) {
                            case 'yes':
                                this.is_communicant = true;
                                break;
                            case 'no':
                                this.is_communicant = false;
                                break;
                        }
                        break;
                    case 'confirmed':
                        switch (value) {
                            case 'yes':
                                this.is_confirmed = true;
                                break;
                            case 'no':
                                this.is_confirmed = false;
                                break;
                        }
                        break;
                    case 'married':
                        switch (value) {
                            case 'yes':
                                this.is_married = true;
                                break;
                            case 'no':
                                this.is_married = false;
                                break;
                        }
                        break;
                }

            },
            toggle_passport_upload: function () {
                // eslint-disable-next-line no-undef
                let passport_box = $('#stdenis-passport');
                passport_box.trigger('click');
            },
            verify_profile_pic_upload() {
                let passport = document.getElementById('stdenis-passport');
                let ext = passport.value.split('.').pop().toLowerCase();
                // eslint-disable-next-line no-undef
                if ($.inArray(ext, ['gif', 'png', 'jpg', 'jpeg']) === -1) {
                    this.display_alert('Oops...', 'incorrect file type!', 'error');
                    passport.value = "";
                    this.profile_pic_url = "";
                    // eslint-disable-next-line no-undef
                    let upload_hint = $('.frame-overlay');
                    // eslint-disable-next-line no-undef
                    $('.pic-frame').css('background-image', '');
                    upload_hint.css('opacity', 1);
                } else {
                    // eslint-disable-next-line no-undef
                    let upload_hint = $('.frame-overlay');
                    upload_hint.css('opacity', 0);
                    this.read_file_url(passport);
                }
            },
            read_file_url(input) {
                if (input.files && input.files[0]) {
                    let reader = new FileReader();
                    reader.onload = (e) => {
                        // eslint-disable-next-line no-undef
                        $('.pic-frame').css('background-image', 'url(' + e.target.result + ')');
                        this.profile_pic_url = e.target.result;
                        this.profile_pic = input.files[0];
                        // save image extension
                        this.profile_pic_ext = input.files[0].name.split('.').pop();
                    };
                    reader.readAsDataURL(input.files[0]);
                }
            },
            set_todays_date: function (inputID) {
                let now = new Date();
                let day = ("0" + now.getDate()).slice(-2);
                let month = ("0" + (now.getMonth() + 1)).slice(-2);
                let today = now.getFullYear() + "-" + (month) + "-" + (day);

                // eslint-disable-next-line no-undef
                $(inputID).val(today);
                this.date_registered = today;
            },
            validate_form_fields() {
                if (this.profile_pic_url.length <= 0) {
                    this.display_alert('Oops...', 'Upload your passport', 'warning');
                    return false
                }
                if (this.surname.length <= 0) {
                    this.display_alert('Oops...', 'fill in your surname', 'warning');
                    return false
                }
                if (this.othername.length <= 0) {
                    this.display_alert('Oops...', 'fill in your other name', 'warning');
                    return false
                }
                if (this.baptismal_name.length <= 0) {
                    this.display_alert('Oops...', 'fill in your baptismal name', 'warning');
                    return false
                }
                if (this.sex.length <= 0) {
                    this.display_alert('Oops...', 'fill in your gender', 'warning');
                    return false
                }
                if (this.maritalStatus.length <= 0) {
                    this.display_alert('Oops...', 'fill in your Marital Status', 'warning');
                    return false
                }
                if (this.dob.length <= 0) {
                    this.display_alert('Oops...', 'fill in your date of birth', 'warning');
                    return false
                }
                if (this.residential_addr.length <= 0) {
                    this.display_alert('Oops...', 'fill in your residential address', 'warning');
                    return false
                }
                if (this.occupation.length <= 0) {
                    this.display_alert('Oops...', 'fill in your occupation', 'warning');
                    return false
                }
                if (this.mobile_no.length <= 6) {
                    this.display_alert('Oops...', 'invalid mobile number', 'error');
                    return false
                }
                // if(this.email.length <= 0){
                //     this.display_alert('Oops...', 'fill in your email address', 'warning');
                //     return false
                // }
                // if(!this.is_email(this.email)){
                //     this.display_alert('Oops...', 'incorrect email format', 'error');
                //     return false
                // }
                if (this.bcc_center.length <= 0) {
                    this.display_alert('Oops...', 'fill in your BCC Center', 'warning');
                    return false
                }
                if (this.yr_joined_church > this.this_year() || this.yr_joined_church <= 1) {
                    this.display_alert('Oops...', 'fill in a valid year', 'warning');
                    return false
                }
                if (this.society_membership === true) {
                    if (this.society_names.length <= 0) {
                        this.display_alert('Oops...', 'select the society he/she belongs to', 'warning');
                        return false
                    }
                }
                if (this.is_baptized === true) {
                    if (this.baptized_date.length <= 0) {
                        this.display_alert('Oops...', 'fill in your baptismal date', 'warning');
                        return false
                    }
                }
                if (this.is_confirmed === true) {
                    if (this.confirmed_date.length <= 0) {
                        this.display_alert('Oops...', 'fill in your confirmation date', 'warning');
                        return false
                    }
                }
                if (this.is_communicant === true) {
                    if (this.communion_date.length <= 0) {
                        this.display_alert('Oops...', 'fill in your communion date', 'warning');
                        return false
                    }
                }
                if (this.is_married === true) {
                    if (this.married_date.length <= 0 || this.married_parish.length <= 0) {
                        this.display_alert('Oops...', 'fill in the remaining marriage details', 'warning');
                        return false
                    }
                }
                if (this.signature_url.length <= 0) {
                    this.display_alert('Oops...', 'Upload your signature', 'warning');
                    return false
                }
                this.submit_signup_details();
            },
            display_alert: function (msg_head, message, error_type) {
                Swal.fire({
                    title: msg_head,
                    showClass: {
                        popup: 'animated fadeInDown faster'
                    },
                    hideClass: {
                        popup: 'animated fadeOutUp faster'
                    },
                    text: message,
                    icon: error_type,
                    showCancelButton: false,
                    showConfirmButton: false,
                    timer: 2000

                })
            },
            is_email(email) {
                var regex = /^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                return regex.test(email);
            },
            submit_signup_details() {
                let loader = this.showLoadingOverlay();
                // eslint-disable-next-line no-unused-vars
                let signupDetails = {
                    BCC: this.bcc_center,
                    baptismalName: this.baptismal_name,
                    dateCreated: firestoreTimeStamp,
                    dateOfBaptism: this.formatDate(this.baptized_date),
                    dateOfBirth: this.formatDate(this.dob),
                    dateOfConfirmation: this.formatDate(this.confirmed_date),
                    dateOfFirstCommunion: this.formatDate(this.communion_date),
                    dateOfMarriage: this.formatDate(this.married_date),
                    dateUpdated: firestoreTimeStamp,
                    email: this.email,
                    familyID: this.parishionerData.familyID,
                    isBaptised: this.is_baptized,
                    isCommunicant: this.is_communicant,
                    isConfirmed: this.is_confirmed,
                    maritalStatus: this.maritalStatus,
                    isMarriedInChurch: this.is_married,
                    nameOfParishWedded: this.married_parish,
                    occupation: this.occupation,
                    otherName: this.othername,
                    parishID: 2,
                    phone: this.mobile_no,
                    picture: '',
                    pictureRef: '',
                    signature: '',
                    signatureRef: '',
                    residentialAddress: this.residential_addr,
                    sex: this.sex,
                    society: this.society_names,
                    statutoryOrganization: this.organization_name,
                    surname: this.surname,
                    yearOfJoiningChurch: this.yr_joined_church
                };
                // eslint-disable-next-line no-unused-vars
                parishioners.add(signupDetails)
                    .then((docRef) => {
                        this.parishioners_doc_ref = docRef.id;
                        let epochTimeInMilliseconds = (new Date).getTime();
                        let filename = this.surname + this.othername + this.baptismal_name + epochTimeInMilliseconds;
                        this.profile_pic_name = filename + '.' + this.profile_pic_ext;
                        this.profilePicRef = 'parishioners_photo/2/' + filename + '/' + this.profile_pic_name;
                        const parishionersImageRef = parishionerStorageREF.child(this.profilePicRef);
                        // upload profile picture
                        return parishionersImageRef.put(this.profile_pic)

                    }).then(snapshot => {
                    return snapshot.ref.getDownloadURL()
                }).then(url => {
                    let ParishionerREF = parishioners.doc(this.parishioners_doc_ref);
                    return ParishionerREF.update({
                        picture: url,
                        pictureRef: this.profilePicRef
                    })
                }).then(() => {
                    // upload signature
                    let epochTimeInMilliseconds = (new Date).getTime();
                    let filename = this.surname + this.othername +this.baptismal_name+ '_signature'+epochTimeInMilliseconds+'.'+this.signature_ext;
                    this.signatureRef = 'parishioners_signature/2/' + filename;
                    const parishionersSigRef = parishionerStorageREF.child(this.signatureRef);
                    return parishionersSigRef.put(this.signature_url)
                }).then(snapshot => {
                    return snapshot.ref.getDownloadURL()
                }).then(url => {
                    let ParishionerREF = parishioners.doc(this.parishioners_doc_ref);
                    return ParishionerREF.update({
                        signature: url,
                        signatureRef: this.signatureRef
                    })
                })
                    .then(() => {
                        let curr_familyID = this.parishionerData.familyID;
                        if (this.maritalStatus === 'married' && this.sex === 'male') {
                            return familyCollection.doc(curr_familyID).update({
                                name: this.surname + " " + this.othername,
                                members: rawFirestore.FieldValue.arrayUnion(this.parishioners_doc_ref)
                            })
                        } else {
                            return familyCollection.doc(curr_familyID).update({
                                members: rawFirestore.FieldValue.arrayUnion(this.parishioners_doc_ref)
                            })
                        }

                    })
                    .then(() => {
                        loader.hide();
                        setTimeout(() => {
                            this.display_alert('success', 'Submitted', 'success');
                            setTimeout(() => {
                                this.$router.go();
                            }, 2500);
                        }, 1000);
                    }).catch((error) => {
                    loader.hide();
                    setTimeout(() => {
                        switch (error.code) {
                            case 'permission-denied':
                                this.display_alert('Error', "Permission Denied!", 'error');
                                break;
                            default:
                                this.display_alert('Error', error, 'error');
                                console.log(error);
                        }
                    }, 1000);

                });
            },
            showLoadingOverlay() {
                return this.$loading.show({
                    // Optional parameters
                    container: this.fullPage ? null : this.$refs.formContainer,
                    canCancel: false,
                });
            },
            formatDate(dateinputValue) {
                if (dateinputValue.length > 0) {
                    return new Date(dateinputValue);
                }
                return ""

            },
            fetchSocieties() {
                societiesREF.get().then((querySnapshot) => {
                    querySnapshot.forEach((doc) => {
                        // doc.data() is never undefined for query doc snapshots
                        let societyID = doc.id;
                        let societyName = doc.data().name;
                        this.societiesName.push({
                            society: societyName,
                            id: societyID
                        });
                        // console.log(JSON.stringify(societyObj));
                    });
                }).catch((error) => {
                    console.warn("Societies Fetch Error: " + error)
                });
            },
            fetchZones() {
                zonesREF.get().then((querySnapshot) => {
                    querySnapshot.forEach((doc) => {
                        // doc.data() is never undefined for query doc snapshots
                        this.bcc_centerID.push(doc.id);
                        this.bcc_centerName.push(doc.data().name);
                    });
                }).catch((error) => {
                    console.warn("Zones Fetch Error: " + error)
                });
            },
            read_sig_url() {
                // eslint-disable-next-line no-undef
                let input_block = $('#signature').prop('files')[0];
                let sig_ext = input_block.name.split('.').pop();
                // eslint-disable-next-line no-undef
                if ($.inArray(sig_ext, ['gif', 'png', 'jpg', 'jpeg']) === -1) {
                    this.display_alert("Oops!", "Wrong file format detected!", "warning");
                } else {
                    this.signature_url = input_block;
                    this.signature_ext = sig_ext;
                    let reader = new FileReader();
                    reader.onload = (e) => {
                        // eslint-disable-next-line no-undef
                        $('.sig-container').css('background-image', 'url(' + e.target.result + ')');
                        // eslint-disable-next-line no-undef
                        $('.inner-hint').text(" change signature");
                    };
                    reader.readAsDataURL(input_block);
                }


            },
            determineOrganization(dob) {
                let now = this.this_year();
                let since = this.formatDate(dob);
                if (since) {
                    let tmp_since_yr = since.getFullYear();
                    let tmp_curr = now - tmp_since_yr;
                    if (this.maritalStatus === 'married') {
                        if (this.sex === 'male') {
                            this.organization_name = "CMO";
                            return "CMO"
                        } else if (this.sex === 'female') {
                            this.organization_name = "CWO";
                            return "CWO"
                        }
                    } else {
                        if (tmp_curr <= 12) {
                            this.society_ID = "MCA";
                            return "MCA"
                        } else {
                            this.society_ID = "CYON"
                        }
                        return "CYON"
                    }
                }
                return ""
            },
            loadParishionerData() {
                parishioners.doc(this.parishionerID).get().then((doc) => {
                    if (doc.exists) {
                        this.parishionerData = doc.data();
                    }
                })
            },
            logout() {
                sessionStorage.clear();
                this.$router.push({name: 'Login'})
            }
        },
        mounted() {
            let tmpID = sessionStorage.getItem('dashboardID');
            if (tmpID) {
                parishioners.doc(tmpID).get().then((doc) => {
                    if (doc.exists) {
                        let usrdata = doc.data();
                        this.profileIcon = usrdata.picture;
                        this.baptismalName = usrdata.baptismalName;
                        this.fetchSocieties();  // Fetch all societies
                        this.fetchZones();      // Fetch all bcc zones
                        this.loadParishionerData();
                    }
                });
            }
        },
        components: {
            'v-select': vSelect
        }
    }
</script>

<style scoped>
    .show {
        display: block !important;
    }

    @media screen and (min-width: 320px) {
        .navbar {
            position: fixed;
            z-index: 999;
            background-color: #3f83d4;
            font-family: "Montserrat", sans-serif !important;
            font-weight: bold;
            transition: all 1s ease-in-out;
            width: 100% !important;
        }

        .navbar-collapse {
            background-color: rgba(0, 0, 0, .7);
            color: #fff;
        }

        .navbar-dark .navbar-nav .nav-link, .navbar-dark .navbar-nav .nav-link em {
            color: #fff;
        }

        .navbar-dark .navbar-nav .nav-link:hover, .navbar-dark .navbar-nav .nav-link em:hover {
            color: #E12993 !important;
        }

        .navbar .navbar-brand img {
            width: 30px;
            height: auto;
        }

        .logo-link:hover {
            color: #fff;
        }

        .side-navbar-toggler {
            position: fixed;
            top: 80px;
            left: 0px;
            z-index: 1;
            width: 40px;
            height: 40px;
            padding: 5px;
            background-color: #3f83d4;
        }

        .side-navbar-toggler:hover {
            cursor: pointer;
        }

        .side-navbar-toggler i {
            font-size: 24px;
        }

        .side-navbar {
            position: fixed;
            display: none;
            width: 60%;
            height: 100%;
            background-color: #439EF3;
            padding-top: 90px;
            z-index: 1;
        }

        .side-navbar > a {
            display: block;
            padding: 10px;
            font-size: 1rem;
        }

        .side-navbar > a, .side-navbar > a > i {
            color: #ffffff;
        }

        .side-navbar > a:hover, .side-navbar > a:hover > i {
            color: #E12993 !important;
        }

        .side-navbar > a:not(:last-child) {
            border-bottom: 1px solid #ffffff;
        }

        .pd-t-100 {
            padding-top: 100px;
        }

        .other-opt {
            background: rgb(250, 250, 250);
            /*width: 100px;*/
        }

        .add-fam > button {
            background-color: #439EF3;
            border-color: #439EF3;
        }

        .user-icon {
            width: 50px;
            height: 50px;
            border-radius: 50%;
            background-color: #666666;
            background-size: cover;
        }
    }

    @media screen and (min-width: 1024px) {
        .navbar-collapse {
            background-color: transparent;
            color: #fff;
        }

        .navbar-brand {
            font-size: 2rem;
        }

        .side-navbar-toggler, .side-navbar-toggler-close {
            display: none;
        }

        .side-navbar {
            width: 15%;
            display: block;
        }
    }

    .m-b-20 {
        margin-bottom: 20px
    }

    .p-t-20 {
        padding-top: 20px
    }

    @media screen and (min-width: 320px) {
        .signup-container {
            border: 2px solid #000;
            padding: 30px;
        }

        .signup-body-1 {
            padding: 30px 20px 30px 20px;
        }

        .signup-container .signup-head {
            border: 1px solid #000;
        }

        .pic-frame {
            width: 100%;
            height: 200px;
            border: 1px solid #439EF3;
            border-radius: 10px;
            background: no-repeat center center;
            background-size: cover;
        }

        .frame-overlay {
            height: 100%;
            border-radius: 5px;
            transition: .5s;
            padding: 70px 20px
        }

        .pic-frame:hover {
            cursor: pointer;
        }

        .pic-frame:hover .frame-overlay {
            opacity: 1;
        }

        .pic-frame input[type="file"] {
            visibility: hidden;
        }

        label {
            width: 100%
        }

        .no-width {
            width: auto;
        }

        .signup-body-2 .gap {
            margin-bottom: 10px;
        }

        .input-mask {
            width: 20px;
            height: 20px;
            background-color: rgb(200, 200, 200);
            margin-right: 10px;
            border-radius: 5px;
        }

        .input-mask:hover {
            cursor: pointer;
        }

        .input-mask.active {
            background-color: #E12993;
        }

        .input-mask > input {
            visibility: hidden;
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0
        }

        .signup-head .head-img img {
            width: 100px;
            height: 100px;
        }

        .signup-head .head-text p {
            font-size: .9rem;
        }

        .signup-head .head-text h1 {
            font-size: 1.3rem;
        }

        .signup-head .head-text h4 {
            font-size: .9rem;
        }

        .signup-body-1 .head-text h4 {
            font-size: 1.2rem;
        }

        .signup-body-header h2 {
            font-size: 1.5rem;
        }

        .signup-body-header h4 {
            font-size: 1.2rem;
        }

        .sig-container {
            width: 200px;
            height: 100px;
            border: 1px solid #439EF3;
            border-radius: 10px;
            position: relative;
            transition: all linear .3s;
            background-size: cover;
        }

        .sig-container #signature {
            visibility: hidden;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 1;
        }

        .sig-container:hover, .sig-container > .hint-text:hover {
            cursor: pointer;
        }

        .sig-container:hover {
            background-color: rgba(0, 0, 0, .2)
        }

        .sig-container > .hint-text {
            /*color: rgb(50,50,50);*/
            text-align: center;
            padding: 7%;
            padding-top: 20%;
            text-transform: lowercase;
            font-size: .8rem;
        }
    }

    @media screen and (min-width: 1024px) {
        .signup-head .head-text .head-img img {
            max-width: 100%;
            height: auto !important;
        }

        .signup-head .head-text h1 {
            font-size: 2.5rem;
        }

        .signup-head .head-text h4, .signup-body-1 .head-text h4, .signup-body-header h4 {
            font-size: 1.5rem;
        }

        .signup-body-header h2 {
            font-size: 2rem;
        }
    }
</style>